import React from 'react';
import { Input } from './Input';

interface ComponentProps {
  filterData: any;
  setFilterData: any;
  name: string;
  placeholder?: string;
  type?: 'text' | 'toggle';
  classes?: string;
}

export const Filter: React.FC<ComponentProps> = ({
  filterData,
  setFilterData,
  name,
  placeholder,
  type = 'text',
  classes,
}) => {
  const renderFilter = (type: string) => {
    switch (type) {
      case 'toggle':
        return (
          <ToggleSwitch
            filterData={filterData}
            name={name}
            onChangeHandler={setFilterData}
            placeholder={placeholder}
          />
        );
      case 'text':
      default:
        return (
          <Input
            inputData={filterData}
            name={name}
            onChangeHandler={setFilterData}
            placeholder={placeholder}
            type={type}
            classes={classes}
          />
        );
    }
  };

  return <>{renderFilter(type)}</>;
};

interface ToggleSwitchComponentProps {
  filterData: any;
  onChangeHandler: any;
  name: string;
  placeholder?: string;
}

const ToggleSwitch: React.FC<ToggleSwitchComponentProps> = ({
  filterData,
  onChangeHandler,
  name,
  placeholder,
}) => {
  return (
    <>
      <label className="inline-flex items-center cursor-pointer my-auto">
        <input
          type="checkbox"
          onChange={() => {
            onChangeHandler({
              ...filterData,
              [name]: !filterData[name],
            });
          }}
          checked={filterData.isActive}
          className="sr-only peer"
        />
        <div className="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:w-5 after:h-5 after:transition-all  peer-checked:bg-blue-600"></div>
        <span className="ms-3 text-sm font-medium text-gray-900">
          {placeholder}
        </span>
      </label>
    </>
  );
};
